import { TransportService } from "../services/TransportService";
import { makeAutoObservable, runInAction } from "mobx";

export interface AppConfig {
  keycloak: {
    keycloakHost: string;
    keycloakRealm: string;
    keycloakClientId: string;
    keycloakIdpHint: string;
    biometricAuthInUse: false;
  };
}

class ConfigStore {
  transportService: TransportService;

  config: AppConfig | null = null;

  constructor(transportService: TransportService) {
    makeAutoObservable(this, {
      transportService: false,
    });
    this.transportService = transportService;
    this.getConfig();
  }

  getConfig = async () => {
    const res = await this.transportService.get(
      "/v1/configuration/application"
    );
    runInAction(() => {
      this.config = res.data;
    });

  };
}

export default ConfigStore;
